export function formatCurrency(n, lang = "ca") {
  const v = Number(n || 0);
  return new Intl.NumberFormat(lang === "es" ? "es-ES" : "ca-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(v);
}

export function formatDate(d, lang = "ca") {
  if (!d) return "—";
  try {
    const date = new Date(d);
    if (isNaN(date.getTime())) return d;
    return new Intl.DateTimeFormat(lang === "es" ? "es-ES" : "ca-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  } catch {
    return d;
  }
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function addDaysISO(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

export function lineTotal(it) {
  const q = Number(it.quantity || 0);
  const p = Number(it.unit_price || 0);
  const disc = Number(it.discount || 0);
  return q * p * (1 - disc / 100);
}

export function computeTotals(items) {
  let subtotal = 0;
  let tax = 0;
  let irpf = 0;
  let disc = 0;
  for (const it of items || []) {
    const line = Number(it.quantity || 0) * Number(it.unit_price || 0);
    const d = line * (Number(it.discount || 0) / 100);
    const after = line - d;
    subtotal += after;
    disc += d;
    tax += after * (Number(it.vat_rate || 0) / 100);
    irpf += after * (Number(it.irpf_rate || 0) / 100);
  }
  return {
    subtotal,
    tax_total: tax,
    irpf_total: irpf,
    discount_total: disc,
    total: subtotal + tax - irpf,
  };
}
